import Axios from 'axios'
// 这里是能力空间专利数据的查询写死方法以及 url
export const patentFun = async ({ query, api }) => {
    const url = api + '/openapi/proxy/patentasset/app_t2p_inter/web_report.do'
    const url1 = api + '/openapi/proxy/patentasset/app_t2p_inter/refreshPat.do'
    const url2 = api + '/openapi/proxy/patentasset/app_t2p_inter/getResult.do'
    const token = JSON.parse(window.localStorage.getItem('user')).accesstoken
    const queryObj = {
        ...query,
        token: 'YHevjba0PeBU5rDF',
        phone: 'wskj',
        ticks: '111'
    }
    const axiosConfig = {
        method: 'post',
        url: url,
        params: queryObj,
        headers: {
            accesstoken: token,
            'Content-Type': 'application/json;charset:utf-8'
        }
    }
    console.log('能力联动发起数据', axiosConfig)
    const { data } = await Axios(axiosConfig).catch(err => { console.log('第一次请求出错', err) })
    console.log('返回的第一个查询res1', data)
    if (data.code == 200) {
        const twoQuery = {
            method: 'post',
            url: url1,
            params: {
                token: queryObj.token,
                report_id: data.report_id
            },
            headers: {
                accesstoken: token,
                'Content-Type': 'application/json;charset:utf-8'
            }
        }
        const res1 = await patentFunTwo(twoQuery).catch(err => { console.log('查询是否生成成功失败', err) })
        if (res1.code == 200) {
            const queryObj2 = {
                ...twoQuery,
                url: url2
            }
            const res2 = await Axios(queryObj2).catch(e => { console.log('最终查询结果错误', e) })
            console.log('查询结果出来了', res2)
            if (res2.data && res2.data.code == 200) {
                try {
                    res2.data.data = JSON.parse(res2.data.data)
                    // 状态码根据提供的匹配值进行匹配一次返回
                    const statusObj = {
                        1: '正常',
                        '-1': '生成错误，请重试',
                        '-2': '无计算值',
                        '-3': '该专利已失效',
                        '-4': '未找到该专利信息',
                        '-8': '专利申请号校验位不对',
                        '-9': '专利不支持计算',
                        '-10': '专利申请号输入错误',
                        '-11': '您的账号已过有效期',
                        '-12': '您的剩余用量已用完'
                    }
                    res2.data.data.forEach(its => {
                        its.STATE = statusObj[its.STATE]
                    })
                } catch (e) { console.log('返回数据格式parse错误', e) }
                return res2.data
            } else {
                return {code : -1, msg: '查询失败'}
            }
        } else {
            return {code : -1, msg: '查询失败'}
        }
    } else {
        return {code : -1, msg: '查询失败'}
    }
}

// 第二个接口查询轮询
function patentFunTwo(query) {
    let promise = new Promise(function(resolve, reject) {
      setTimeout(async () => {
        const {data} = await Axios(query).catch(e => { reject(e) })
        if (data.code == 200) {
            if (data.STATE === 1) {
                resolve(data);
            } else {
                resolve(patentFunTwo(query))
            }
        } else {
            reject({msg: '查询错误'});
        }
      }, 150);
    });
    return promise;
 }
